import React, { useState } from "react";
import styles from "./StudentCheckOut.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { BiLogIn } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const StudentCheckOut = () => {
  const [formData, setFormData] = useState({
    hour: "12",
    minute: "00",
    period: "PM",
    markLate: false,
    notes: "",
    temperature: "",
    notifyStaff: "",
    notifyParent: false,
  });
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCancel = () => {
    setFormData({
      hour: "12",
      minute: "00",
      period: "PM",
      markLate: false,
      notes: "",
      temperature: "",
      notifyStaff: "",
      notifyParent: false,
    });
  };

  const handleSave = () => {
    console.log("Check-in Saved:", formData);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerBox}>
        <HeadingAndIcon
          icon={<BiLogIn size={22} />}
          heading="Check Out Details"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.formContent}>
        <div className={styles.timeRow}>
          <div className={styles.timeGroup}>
            <div className={styles.timeUnit}>
              <label className={styles.timeLabel}>
                Check in Time <span className={styles.required}>*</span>
              </label>
              <div className={styles.inlineTimeInputs}>
                <select
                  name="hour"
                  value={formData.hour}
                  onChange={handleChange}
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={String(i + 1).padStart(2, "0")}>
                      {String(i + 1).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <span className={styles.colon}>:</span>
                <select
                  name="minute"
                  value={formData.minute}
                  onChange={handleChange}
                >
                  {Array.from({ length: 60 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <span className={styles.colon}>:</span>
                <select
                  name="period"
                  value={formData.period}
                  onChange={handleChange}
                >
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </div>
            </div>
          </div>

          <label className={styles.checkboxWrap}>
            <input
              type="checkbox"
              name="markLate"
              checked={formData.markLate}
              onChange={handleChange}
            />
            Mark Late check In
          </label>
        </div>

        <div className={styles.inputBlock}>
          <label htmlFor="notes" className={styles.inputLabel}>
            Notes *
          </label>
          <textarea
            id="notes"
            name="notes"
            className={styles.textarea}
            placeholder="Enter any notes ..."
            value={formData.notes}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <HeadingAndData
          label="Temperature (in F)"
          name="temperature"
          value={formData.temperature}
          onChange={handleChange}
          required
        />

        <HeadingAndDropDown
          label="Notify Staff"
          name="notifyStaff"
          value={formData.notifyStaff}
          onChange={handleChange}
          options={[
            { value: "Darshan", label: "Darshan" },
            { value: "Ravi", label: "Ravi" },
          ]}
          required
        />

        <label className={styles.checkboxWrap}>
          <input
            type="checkbox"
            name="notifyParent"
            checked={formData.notifyParent}
            onChange={handleChange}
          />
          Send Notification to parent
        </label>

        <SaveAndCancel
          onCancel={handleCancel}
          onSave={handleSave}
          saveLabel="Check Out"
          cancelLabel="Cancel"
        />
      </div>
    </div>
  );
};

export default StudentCheckOut;
